import type { Story } from '@/store/story-types'

export const LANDING_PAGE_STORY: Story = {
  id: 'landing-page-1',
  name: 'SaaS Landing Page',
  narrative: 'A modern SaaS landing page that introduces the product, highlights key features, presents pricing plans, and converts visitors into users through a sign-up flow.',
  goals: ['Introduce product', 'Showcase features', 'Present pricing', 'Convert sign-ups'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 6, linkedPageId: 'page-home', description: 'Single-page landing with hero, features, pricing, and sign-up sections',
      blockRef: { category: 'landing', blockId: 'landing-hero' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Hero',
      description: 'Visitor sees the hero section on the homepage',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero headline, subtitle, CTA buttons, and stats are visible', linkedPageId: 'page-home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Explore Features',
      description: 'Visitor navigates to the features page',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'they navigate to the Features page' },
        { type: 'then', text: '4 feature cards with icons are displayed', linkedPageId: 'page-features' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Compare Pricing',
      description: 'Visitor compares pricing tiers',
      steps: [
        { type: 'given', text: 'the visitor wants to see pricing' },
        { type: 'when', text: 'they navigate to the Pricing page' },
        { type: 'then', text: '3 tiers (Free, Pro, Enterprise) with feature lists and CTAs are shown', linkedPageId: 'page-pricing' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Sign Up',
      description: 'Visitor signs up for an account',
      steps: [
        { type: 'given', text: 'the visitor clicks Get Started' },
        { type: 'when', text: 'the sign-up form loads', linkedPageId: 'page-signup' },
        { type: 'then', text: 'name, email, and password fields with a submit button are displayed' },
        { type: 'and', text: 'the form validates inputs before submission', linkedFlowId: 'validateSignup' },
      ],
    },
  ],
}
